<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .toggle {
    position: absolute;
    top: 0;
    right: 0;
  }

  .filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: utils.in_rem(8px);
    padding-bottom: utils.in_rem(12px);

    > .label {
      @include mixins.body3-tooltip-and-caption();
    }

    > .dropdown {
      width: utils.in_rem(220px);
    }

    &.is-overlay {
      justify-content: left;
    }
    &:not(.is-overlay) {
      justify-content: right;
    }
  }
</style>

<script>
  // Stores
  import { isOverlayStore } from "./stores";
  // Components
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import MultiSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/MultiSelectDropdown/MultiSelectDropdown.svelte";

  export let items = [];
  export let selectedItems = [];
  export let disabled = false;

  // bind to this so we can reset it when the parent stores change
  export let show = false;

  const onclick = () => {
    show = !show;
  };

  $: trailingIcon = show ? "fa-chevron-up" : "fa-chevron-down";
</script>

<!-- Filter is always shown in overlay mode -->
{#if !$isOverlayStore}
  <div class="toggle">
    <Button
      kind="ghost-grey"
      size="small"
      leadingIcon="far fa-filter"
      {trailingIcon}
      {onclick}
      {disabled}
      class={disabled ? "disabled" : ""}
      style="outline-offset: -2px;"
    >
      Filters
    </Button>
  </div>
{/if}

{#if show || $isOverlayStore}
  <div class="filter" class:is-overlay={$isOverlayStore}>
    <div class="label">Filter by tag:</div>
    <div class="dropdown">
      <MultiSelectDropdown
        {items}
        bind:selectedItems
        size="small"
        placeholder="No filter applied"
        style="width:100%; outline-offset: -2px;"
      />
    </div>
  </div>
{/if}
